/* Existing Shopify banner is the default; the optional theme panel is off in settings. */
(() => {
  'use strict';
  const panel = document.querySelector('.cookie-panel');
  function notice(text, target) {
    let status = document.querySelector('[data-privacy-status]');
    if (!status) { status = document.createElement('p'); status.dataset.privacyStatus = ''; status.setAttribute('role', 'status'); (target?.parentElement || document.body).append(status); }
    status.textContent = text;
  }
  function api() {
    return new Promise((resolve, reject) => {
      if (window.Shopify?.customerPrivacy) { resolve(window.Shopify.customerPrivacy); return; }
      if (!window.Shopify?.loadFeatures) { reject(new Error('Privacy settings are not available yet. Please refresh and try again.')); return; }
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => error ? reject(error) : resolve(window.Shopify.customerPrivacy));
    });
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cookie-open]');
    if (!button) return;
    event.preventDefault();
    if (panel) { panel.hidden = false; return; }
    try {
      const banner = window.privacyBanner || window.Shopify?.privacyBanner;
      if (typeof banner?.showPreferences === 'function') { await banner.showPreferences(); return; }
      const manage = document.getElementById('shopify-pc__banner__btn-manage-prefs');
      if (manage) { manage.click(); return; }
      // The native API may be initialized after this theme script.
      await api();
      const late = window.privacyBanner || window.Shopify?.privacyBanner;
      if (typeof late?.showPreferences === 'function') { await late.showPreferences(); return; }
      notice('Privacy preferences could not be opened. Please refresh this page and try again, or contact customer support.', button);
    } catch { notice('Privacy preferences could not be opened. Please refresh this page and try again.', button); }
  });
  if (!panel) return;
  api().then(privacy => {
    const consent = privacy.currentVisitorConsent?.();
    if (!consent || !['analytics','marketing','preferences'].some(key => consent[key] === 'yes' || consent[key] === 'no')) panel.hidden = false;
    panel.querySelectorAll('[data-consent]').forEach(button => button.addEventListener('click', () => {
      const allow = button.dataset.consent === 'accept' && !navigator.globalPrivacyControl;
      const buttons = [...panel.querySelectorAll('button')];
      buttons.forEach(b => b.disabled = true);
      privacy.setTrackingConsent({ analytics: allow, marketing: allow, preferences: allow, sale_of_data: allow }, () => { panel.hidden = true; buttons.forEach(b => b.disabled = false); });
    }));
  }).catch(() => { panel.hidden = false; notice('Consent settings could not be loaded. Please refresh before choosing your preferences.', panel.querySelector('button')); });
})();
